export const PERMS = {
    STORE_READ: 'store:read',
    STORE_WRITE: 'store:write',
    ACCOUNT_READ: 'account:read',
    ACCOUNT_WRITE: 'account:write',
    COURSE_TEMPLATE_WRITE: 'course_template:write',
    COURSE_SESSION_READ: 'course_session:read',
    COURSE_SESSION_WRITE: 'course_session:write',
    BOOKING_OWN_READ: 'booking:own:read',
    BOOKING_ANY_READ: 'booking:any:read',
    TRAINING_RECORD_READ: 'training_record:read',
    TRAINING_RECORD_WRITE: 'training_record:write',
    REHAB_RECORD_WRITE: 'rehab_record:write',
    REPORT_VIEW_STORE: 'report:store:view',
    REPORT_VIEW_PLATFORM: 'report:platform:view',
    ADMIN_USER_DISABLE: 'admin:user:disable',
    ADMIN_AUDIT_READ: 'admin:audit:read',
    COUPON_ISSUE: 'coupon:issue',
    ORDER_REFUND: 'order:refund',
    RESCHEDULE_DECIDE: 'reschedule:decide',
    // #210：可配置身份/账号管理（自定义 RBAC）
    RBAC_MANAGE: 'rbac:manage',
    // 二期：运营标签库维护（来源标签 / 业务标签）
    TAG_MANAGE: 'tag:manage',
    // 二期：作废记录（不物理删除）。需求要求仅总管理员，故不挂进 ROLE_PERMS.manager
    RECORD_VOID: 'record:void',
    // 二期：后台录入线下成交订单。与 RECORD_VOID 有意不同权——门店经理谈单录单是日常，
    // 撤销账面（作废冲正）是财务动作，只给总管理员。
    ORDER_OFFLINE_CREATE: 'order:offline_create',
    // 二期：后台人工代预约（含未注册新客建档、弹性体验课现排）。前台与门店经理日常要用。
    BOOKING_ASSIST: 'booking:assist',
    // 二期：编辑已有记录（需求二「编辑权限为普通后台管理员可操作」）
    RECORD_EDIT: 'record:edit',
    // 二期：修正来源标签。归因是报表的地基，改动会让历史统计口径漂移且无人察觉，
    // 故与普通编辑分开、只给总管理员。
    SOURCE_TAG_CORRECT: 'source_tag:correct',
    // 828：看板签到（确认学员是否到场）。单独成点，好让前台这类自定义身份只拿到
    // 签到能力，而不必连带整个预约读写权限。
    BOOKING_CHECK_IN: 'booking:check_in',
    // 828：0 金额单（意向咨询/免费体验/实付 0）的店长确认。确认前不能据此预约。
    ORDER_ZERO_CONFIRM: 'order:zero_confirm',
    /**
     * 消缺 300：运营内容维护（Banner / 积分规则 / 兑换商品 / 充值档位 / 关于我们 / 协议）。
     *
     * 这几个接口此前借 ADMIN_USER_DISABLE 当守卫，纯属找了个「超管才有」的权限凑数。
     * 但那个权限同时管着「停用员工账号 / 停用家长账号」——要让自定义身份能改 Banner，
     * 就得连停用账号的能力一起给出去，属于越权。拆成独立一点，运营归运营、账号归账号。
     */
    OPS_CONTENT_WRITE: 'ops:content:write',
    /**
     * 消缺 297/298：取消某一条预约（后台强制取消，按原路退回课时）。
     *
     * 训练侧原先借 COURSE_SESSION_WRITE、康复侧借 RESCHEDULE_DECIDE——两边不一致，
     * 而且都过宽：取消一条预约不该顺带给出「改排课表」「审批改期」的能力。
     * 单独成点后，预约统计这类页面可以只拿到「能取消」。
     */
    BOOKING_CANCEL: 'booking:cancel',
};
export const ROLE_PERMS = {
    user: [PERMS.BOOKING_OWN_READ],
    coach: [
        PERMS.COURSE_SESSION_READ,
        PERMS.COURSE_SESSION_WRITE,
        PERMS.BOOKING_ANY_READ,
        PERMS.TRAINING_RECORD_READ,
        PERMS.TRAINING_RECORD_WRITE,
        PERMS.BOOKING_CHECK_IN,
    ],
    rehab_th: [
        PERMS.REHAB_RECORD_WRITE,
        PERMS.BOOKING_ANY_READ,
        PERMS.COURSE_SESSION_READ,
    ],
    manager: [
        PERMS.STORE_READ,
        PERMS.ACCOUNT_READ,
        PERMS.ACCOUNT_WRITE,
        PERMS.COURSE_TEMPLATE_WRITE,
        PERMS.COURSE_SESSION_READ,
        PERMS.COURSE_SESSION_WRITE,
        PERMS.BOOKING_ANY_READ,
        PERMS.TRAINING_RECORD_READ,
        PERMS.REPORT_VIEW_STORE,
        PERMS.COUPON_ISSUE,
        PERMS.RESCHEDULE_DECIDE,
        PERMS.TAG_MANAGE,
        PERMS.ORDER_OFFLINE_CREATE,
        PERMS.BOOKING_ASSIST,
        PERMS.RECORD_EDIT,
        PERMS.BOOKING_CHECK_IN,
        PERMS.ORDER_ZERO_CONFIRM,
        PERMS.BOOKING_CANCEL,
        PERMS.OPS_CONTENT_WRITE,
    ],
    // 828：业务员目前只由后台添加、参与统计与成交顾问选择，不开放登录与后台操作
    business: [],
    admin: Object.values(PERMS),
};
export const PAGE_PERMS = [
    // 客户预约
    { key: 'page:data.offline_entry', group: '客户预约', label: '线下资料录入', path: '/ops/offline-orders/new', requires: [PERMS.ORDER_OFFLINE_CREATE] },
    { key: 'page:dashboard.grid_training', group: '客户预约', label: '预约课时(训练)', path: '/dashboard/booking-grid-training', requires: [PERMS.BOOKING_ANY_READ, PERMS.BOOKING_ASSIST, PERMS.BOOKING_CHECK_IN, PERMS.TRAINING_RECORD_WRITE, PERMS.BOOKING_CANCEL] },
    { key: 'page:dashboard.grid_rehab', group: '客户预约', label: '预约课时(康复)', path: '/dashboard/booking-grid-rehab', requires: [PERMS.BOOKING_ANY_READ, PERMS.BOOKING_ASSIST, PERMS.BOOKING_CHECK_IN, PERMS.BOOKING_CANCEL] },
    { key: 'page:dashboard.pending_confirm', group: '客户预约', label: '待确认登记', path: '/ops/offline-orders/pending', requires: [PERMS.ORDER_OFFLINE_CREATE, PERMS.ORDER_ZERO_CONFIRM] },
    // 消缺 332：客户预约包含课表，数字看板只保留总览与营收。
    // key 不改——它们存在 RoleDef.permissions 里，改 key 要做数据迁移；只改 group。
    // 数字看板
    { key: 'page:dashboard.overview', group: '数字看板', label: '总览', path: '/dashboard/overview', requires: [PERMS.REPORT_VIEW_STORE] },
    { key: 'page:dashboard.revenue', group: '数字看板', label: '营收明细', path: '/dashboard/revenue', requires: [PERMS.REPORT_VIEW_STORE] },
    // 数据
    { key: 'page:data.orders', group: '数据', label: '订单', path: '/ops/orders', requires: [PERMS.STORE_READ] },
    { key: 'page:data.exchange_training', group: '数据', label: '兑换课时(训练)', path: '/dashboard/exchange-detail-training', requires: [PERMS.REPORT_VIEW_PLATFORM, PERMS.ORDER_OFFLINE_CREATE, PERMS.RECORD_EDIT] },
    { key: 'page:data.exchange_rehab', group: '数据', label: '兑换课时(康复)', path: '/dashboard/exchange-detail-rehab', requires: [PERMS.REPORT_VIEW_PLATFORM, PERMS.ORDER_OFFLINE_CREATE, PERMS.RECORD_EDIT] },
    { key: 'page:dashboard.by_source', group: '数据', label: '来源统计', path: '/reports/by-source', requires: [PERMS.REPORT_VIEW_PLATFORM] },
    { key: 'page:data.booking_training', group: '数据', label: '预约统计(训练)', path: '/dashboard/booking-detail-training', requires: [PERMS.REPORT_VIEW_PLATFORM, PERMS.BOOKING_ASSIST, PERMS.RECORD_EDIT] },
    { key: 'page:data.booking_rehab', group: '数据', label: '预约统计(康复)', path: '/dashboard/booking-detail-rehab', requires: [PERMS.REPORT_VIEW_PLATFORM, PERMS.BOOKING_ASSIST, PERMS.RECORD_EDIT] },
    { key: 'page:data.training_records', group: '数据', label: '训练记录', path: '/courses/training-records', requires: [PERMS.TRAINING_RECORD_READ] },
    { key: 'page:data.rehab_records', group: '数据', label: '康复记录', path: '/rehabs/records', requires: [PERMS.TRAINING_RECORD_READ] },
    // 会员
    { key: 'page:members.accounts', group: '会员', label: '账号', path: '/members/accounts', requires: [PERMS.ACCOUNT_READ, PERMS.ACCOUNT_WRITE] },
    { key: 'page:members.students', group: '会员', label: '学员', path: '/members/students', requires: [PERMS.ACCOUNT_READ, PERMS.ACCOUNT_WRITE] },
    // 闯关体适能（原「训练」，消缺 331 改名）
    { key: 'page:training.templates', group: '闯关体适能', label: '课程模板', path: '/courses/templates', requires: [PERMS.STORE_READ, PERMS.COURSE_TEMPLATE_WRITE] },
    { key: 'page:training.coaches', group: '闯关体适能', label: '教练', path: '/courses/coaches', requires: [PERMS.STORE_READ, PERMS.ACCOUNT_READ, PERMS.ACCOUNT_WRITE] },
    { key: 'page:training.packages', group: '闯关体适能', label: '套餐', path: '/courses/packages', requires: [PERMS.STORE_READ, PERMS.STORE_WRITE] },
    // 消缺 300：「新建排课」要 course_session:write，此前只给了 read → Missing permission
    { key: 'page:training.sessions', group: '闯关体适能', label: '排课日历', path: '/courses/sessions', requires: [PERMS.COURSE_SESSION_READ, PERMS.COURSE_SESSION_WRITE] },
    // 运动康复中心（原「康复」，消缺 331 改名）
    { key: 'page:rehab.therapists', group: '运动康复中心', label: '康复师', path: '/rehabs/therapists', requires: [PERMS.STORE_READ, PERMS.ACCOUNT_READ, PERMS.ACCOUNT_WRITE] },
    { key: 'page:rehab.packages', group: '运动康复中心', label: '康复套餐', path: '/rehabs/packages', requires: [PERMS.STORE_READ, PERMS.STORE_WRITE] },
    // 康复排课日历打的是 rehab-appointments：列表要 booking:any:read，新建时段 / 批量复制 / 取消要 reschedule:decide
    { key: 'page:rehab.scheduling', group: '运动康复中心', label: '排课日历', path: '/rehabs/scheduling', requires: [PERMS.BOOKING_ANY_READ, PERMS.RESCHEDULE_DECIDE] },
    // 门店
    { key: 'page:stores.list', group: '门店', label: '门店列表', path: '/stores/list', requires: [PERMS.STORE_READ, PERMS.STORE_WRITE] },
    { key: 'page:stores.managers', group: '门店', label: '店长列表', path: '/stores/managers', requires: [PERMS.STORE_READ, PERMS.STORE_WRITE] },
    { key: 'page:stores.business', group: '门店', label: '业务列表', path: '/stores/business', requires: [PERMS.STORE_READ, PERMS.ACCOUNT_WRITE] },
    // 运营
    // 消缺 300：这几页的写接口原先借 ADMIN_USER_DISABLE 当守卫（连带着停用账号的能力），
    // 已拆成独立的 OPS_CONTENT_WRITE，页面权限只发这一个。
    { key: 'page:ops.banners', group: '运营', label: 'Banner', path: '/ops/banners', requires: [PERMS.OPS_CONTENT_WRITE] },
    { key: 'page:ops.points', group: '运营', label: '积分', path: '/ops/points', requires: [PERMS.OPS_CONTENT_WRITE] },
    { key: 'page:ops.reward_items', group: '运营', label: '兑换商品', path: '/ops/reward-items', requires: [PERMS.OPS_CONTENT_WRITE] },
    { key: 'page:ops.exchanges', group: '运营', label: '兑换单', path: '/ops/exchanges', requires: [PERMS.ACCOUNT_READ, PERMS.ACCOUNT_WRITE] },
    { key: 'page:ops.recharge', group: '运营', label: '充值管理', path: '/ops/recharge', requires: [PERMS.STORE_READ, PERMS.OPS_CONTENT_WRITE] },
    { key: 'page:ops.messages', group: '运营', label: '消息广播', path: '/ops/messages', requires: [PERMS.ACCOUNT_READ, PERMS.ACCOUNT_WRITE] },
    // 营销
    { key: 'page:marketing.coupons', group: '营销', label: '优惠券列表', path: '/ops/coupons', requires: [PERMS.COUPON_ISSUE, PERMS.ACCOUNT_READ, PERMS.ACCOUNT_WRITE] },
    { key: 'page:marketing.coupon_issue', group: '营销', label: '手动发券', path: '/ops/coupons/issue', requires: [PERMS.COUPON_ISSUE, PERMS.ACCOUNT_READ, PERMS.ACCOUNT_WRITE] },
    { key: 'page:marketing.coupon_usage', group: '营销', label: '优惠券使用', path: '/ops/coupons/usage', requires: [PERMS.COUPON_ISSUE, PERMS.ACCOUNT_READ] },
    // 邀请设置页打的是 lottery 接口（抽奖设置 / 奖品增删改），守卫是 account:write
    { key: 'page:marketing.invite_settings', group: '营销', label: '邀请设置', path: '/marketing/invites/settings', requires: [PERMS.COUPON_ISSUE, PERMS.ACCOUNT_READ, PERMS.ACCOUNT_WRITE] },
    { key: 'page:marketing.invite_list', group: '营销', label: '邀请列表', path: '/marketing/invites/list', requires: [PERMS.COUPON_ISSUE, PERMS.ACCOUNT_READ] },
    { key: 'page:marketing.invite_draws', group: '营销', label: '抽奖明细', path: '/marketing/invites/draws', requires: [PERMS.COUPON_ISSUE, PERMS.ACCOUNT_READ] },
    // 系统
    { key: 'page:system.staff', group: '系统', label: '超管账号', path: '/system/staff', requires: [PERMS.RBAC_MANAGE] },
    { key: 'page:system.admins', group: '系统', label: '管理员', path: '/system/admins', requires: [PERMS.RBAC_MANAGE] },
    { key: 'page:system.roles', group: '系统', label: '身份权限', path: '/system/roles', requires: [PERMS.RBAC_MANAGE] },
    { key: 'page:system.audit_logs', group: '系统', label: '审计日志', path: '/system/audit-logs', requires: [PERMS.ADMIN_AUDIT_READ] },
    { key: 'page:system.about', group: '系统', label: '关于我们', path: '/system/about', requires: [PERMS.OPS_CONTENT_WRITE] },
    { key: 'page:system.agreements', group: '系统', label: '协议管理', path: '/system/agreements', requires: [PERMS.OPS_CONTENT_WRITE] },
    { key: 'page:data.tags', group: '系统', label: '标签管理', path: '/ops/tags', requires: [PERMS.TAG_MANAGE] },
];
/** 菜单栏目顺序，权限树按它排 */
export const PAGE_PERM_GROUPS = ['客户预约', '数字看板', '数据', '会员', '闯关体适能', '运动康复中心', '门店', '运营', '营销', '系统'];
const PAGE_PERM_BY_KEY = new Map(PAGE_PERMS.map((p) => [p.key, p]));
export function isPagePerm(key) {
    return PAGE_PERM_BY_KEY.has(key);
}
/**
 * 把勾选的页面权限点展开成「页面点 + 它需要的能力点」。
 *
 * 不展开的话，勾了「订单」的身份能看见菜单项，点进去却撞 403——
 * 对使用者来说这和没授权没区别，但排查起来要绕一大圈。
 */
export function expandPagePerms(keys) {
    const out = new Set(keys);
    for (const k of keys) {
        const def = PAGE_PERM_BY_KEY.get(k);
        if (def)
            for (const r of def.requires)
                out.add(r);
    }
    return [...out];
}
//# sourceMappingURL=permissions.js.map